import { axios } from 'lib'
import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'

const createMinimumOrderByProductGroup = async (data: any): Promise<any> => {
  return await axios.post('/parameters/min-order-per-product-group', data)
}

export function useCreateMinimumOrderByProductGroup() {
  const queryClient = useQueryClient()

  return useMutation(createMinimumOrderByProductGroup, {
    onSuccess: () => {
      queryClient.invalidateQueries('minimumOrdersByProductGroup')
      toast.success(
        'Pedido mínimo por grupo de produto adicionado com sucesso!'
      )
    },
    onError: (error: unknown) => {
      console.error(error)
      toast.error(
        'Não foi possível adicionar pedido mínimo por grupo de produto!'
      )
    }
  })
}
